(function () {
  'use strict';

  if (window.ArezzoCustomContactForm) {
    return;
  }

  var instances = new Map();

  function initializeAll(root) {
    var scope = root || document;
    var configElements = [];

    if (scope.matches && scope.matches('[data-custom-contact-form-config]')) {
      configElements.push(scope);
    }

    if (scope.querySelectorAll) {
      configElements = configElements.concat(
        Array.prototype.slice.call(
          scope.querySelectorAll('[data-custom-contact-form-config]')
        )
      );
    }

    configElements.forEach(initializeSection);
  }

  function initializeSection(configElement) {
    var config;

    try {
      config = JSON.parse(configElement.textContent);
    } catch (error) {
      console.error('Custom contact form configuration is invalid.');
      return;
    }

    var SECTION_ID = String(config.sectionId || '');
    var formElement = document.getElementById(config.formId);

    if (
      !SECTION_ID ||
      !formElement ||
      !window.jQuery ||
      !window.jQuery.fn ||
      typeof window.jQuery.fn.validate !== 'function' ||
      typeof window.intlTelInput !== 'function'
    ) {
      console.error('Custom contact form dependencies are unavailable.');
      return;
    }

    if (instances.has(SECTION_ID)) {
      destroySection(SECTION_ID);
    }

    var $ = window.jQuery;
    var form = $(formElement);
    var inputPhone = document.getElementById('Phone-' + SECTION_ID);
    var errorMsg = document.getElementById('error-msg-' + SECTION_ID);

    if (!inputPhone || !errorMsg) {
      console.error('Custom contact form markup is incomplete.');
      return;
    }

    var errorMap = config.messages.phoneErrors;

  var iti = window.intlTelInput(inputPhone, {
    utilsScript: config.intlTelUtilsUrl,
    separateDialCode: true,
  });

  var isSubmitting = false;

  var submitButton = form.find('.contact__button button');
  var submitButtonOriginalText = submitButton.text();

  /*
   * The submit button stays in the DOM and visible during the request: hiding a
   * focused control moves focus to the document and loses the user's place.
   */
  function setFormSubmitting(submitting) {
    isSubmitting = !!submitting;

    if (submitting) {
      form.attr('aria-busy', 'true');

      submitButton
        .prop('disabled', true)
        .attr('aria-disabled', 'true')
        .text(config.messages.submit.sending);

      form.find('.contact__spinner').show();
      return;
    }

    form.removeAttr('aria-busy');

    submitButton
      .prop('disabled', false)
      .removeAttr('aria-disabled')
      .text(config.messages.submit.send || submitButtonOriginalText);

    form.find('.contact__spinner').hide();
  }

function setFormSubmitted() {
  isSubmitting = true;

  form.removeAttr('aria-busy');
  form.find('.contact__spinner').hide();

  form.find('.contact__button').hide();
}

  // form-success and form-error are the only announced regions, and focus moves
  // to exactly one of them.
  function showFormSuccess() {
    var successMessage = form.find('.form-success');

    form.find('.form-error').addClass('hidden');
    successMessage.removeClass('hidden');

    focusWithoutScroll(successMessage.get(0));
  }

  function showFormError() {
    var errorMessage = form.find('.form-error');

    form.find('.form-success').addClass('hidden');
    errorMessage.removeClass('hidden');

    focusWithoutScroll(errorMessage.get(0));
  }

  // --- Session lock (5 min) ---
  var CONTACT_SENT_KEY = 'arezzo_contact_sent_at';
  var CONTACT_LOCK_DURATION = 5 * 60 * 1000;

  var lastContactSent = Number(sessionStorage.getItem(CONTACT_SENT_KEY) || 0);
  var contactRecentlySent = lastContactSent > 0 && (Date.now() - lastContactSent < CONTACT_LOCK_DURATION);

if (contactRecentlySent) {
  form.find('.contact__button').hide();
  form.find('.contact-success-btn').removeClass('hidden');
  form.find('.form-success').removeClass('hidden');
} else if (lastContactSent > 0) {
    sessionStorage.removeItem(CONTACT_SENT_KEY);
  }

  // --- Phone validation helpers ---
  function resetPhoneError() {
    errorMsg.textContent = '';
    errorMsg.classList.remove('error');
    errorMsg.classList.add('hide');
  }

  function validatePhone() {
    resetPhoneError();

    if (!inputPhone.value.trim()) {
      return true;
    }

    if (!iti.isValidNumber()) {
      var errorCode = iti.getValidationError();
      errorMsg.textContent = errorMap[errorCode] || errorMap[0];
      errorMsg.classList.add('error');
      errorMsg.classList.remove('hide');
      inputPhone.focus();
      return false;
    }

    return true;
  }

  // Phone blur/change/keyup listeners (named for dedup)
  function handlePhoneBlur() {
    resetPhoneError();
    if (inputPhone.value.trim()) {
      if (!iti.isValidNumber()) {
        var errorCode = iti.getValidationError();
        errorMsg.textContent = errorMap[errorCode] || errorMap[0];
        errorMsg.classList.add('error');
        errorMsg.classList.remove('hide');
      }
    }
  }

  inputPhone.removeEventListener('blur', handlePhoneBlur);
  inputPhone.removeEventListener('change', resetPhoneError);
  inputPhone.removeEventListener('keyup', resetPhoneError);

  inputPhone.addEventListener('blur', handlePhoneBlur);
  inputPhone.addEventListener('change', resetPhoneError);
  inputPhone.addEventListener('keyup', resetPhoneError);

  // --- Returns flow (feature flagged) ---
  var RETURNS_ENABLED = config.returnsEnabled;

  var RETURNS_PAYLOAD_FIELDS = [
    'returnReasonCode',
    'returnSubreasonCode',
    'returnDetailsTxt',
    'returnItemsJson',
    'returnItemsTxt',
    'returnItemCountNum',
    'returnRequestIdStr',
    'orderValidationStatusStr',
  ];

  // Which return reason / subreason paths require the free-text details field.
  var RETURN_DETAILS_BY_REASON = config.messages.returnDetailsByReason;
  var RETURN_DETAILS_BY_SUBREASON = config.messages.returnDetailsBySubreason;
  var ORDER_VERIFY_URL = config.orderVerifyUrl;
  var FIND_ORDER_LABEL = config.messages.orderLookup.findOrder;
  var ORDER_LOOKUP_MESSAGES = config.messages.orderLookup;
  var RETURNS_SUBMIT_MESSAGES = config.messages.returnsSubmit;

  // Worker error codes that mean the verified order is no longer usable.
  var RETURN_VALIDATION_ERROR_CODES = [
    'return_validation_required',
    'return_validation_invalid',
    'return_validation_expired',
    'invalid_return_items',
    'invalid_return_reason',
  ];

  /*
   * Idempotency outcomes. None of them triggers an automatic retry: the
   * customer decides whether to submit again.
   */
  var RETURN_IDEMPOTENCY_MESSAGES = config.messages.returnIdempotency;

  // --- Damage photos (feature flagged) ---
  var RETURN_PHOTOS_ENABLED = config.returnPhotosEnabled;

  var MAX_RETURN_PHOTO_COUNT = 3;
  var MAX_RETURN_PHOTO_SIZE_BYTES = 5 * 1024 * 1024;
  var MAX_RETURN_PHOTO_TOTAL_BYTES = 15 * 1024 * 1024;

  var ALLOWED_RETURN_PHOTO_TYPES = [
    'image/jpeg',
    'image/png',
    'image/webp',
  ];

  var RETURN_PHOTO_MESSAGES = config.messages.returnPhotos;

  // Files stay in memory only: never a hidden input, storage, cookie, data
  // attribute or base64 string.
  var returnPhotoFiles = [];
  var returnPhotoObjectUrls = [];

  var EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  var MAX_RETURN_IMAGE_URL_LENGTH = 2048;
  var MAX_RETURN_IMAGE_ALT_LENGTH = 300;

  // The verified order lives in memory only. The validationToken must never
  // reach storage, a hidden field, an attribute or a log.
  var verifiedOrderState = null;
  var isFindingOrder = false;
  // Incremented on every lookup and on every invalidation, so a stale response
  // can never paint the UI.
  var findOrderRequestSeq = 0;
  var findOrderAbortController = null;

  var contactReasonSelect = document.querySelector('#contactReason-' + SECTION_ID);
  var emailInput = document.querySelector('#Email-' + SECTION_ID);
  var orderInput = document.querySelector('#order-' + SECTION_ID);
  var orderRequiredMarker = $('#orderRequiredMarker-' + SECTION_ID);
  var returnsFlow = $('#returnsFlow-' + SECTION_ID);
  var findOrderButton = $('#findOrder-' + SECTION_ID);
  var returnsOrderStatus = $('#returnsOrderStatus-' + SECTION_ID);
  var returnsItems = $('#returnsItems-' + SECTION_ID);
  var returnsItemsList = $('#returnsItemsList-' + SECTION_ID);
  var returnsItemsError = $('#returnsItemsError-' + SECTION_ID);
  var returnsReason = $('#returnsReason-' + SECTION_ID);
  var returnsSubreasonIncorrect = $('#returnsSubreasonIncorrect-' + SECTION_ID);
  var returnsSubreasonFit = $('#returnsSubreasonFit-' + SECTION_ID);
  var returnsDetails = $('#returnsDetails-' + SECTION_ID);
  var returnDetailsInput = $('#returnDetails-' + SECTION_ID);
  var returnDetailsLabel = $('#returnDetailsLabel-' + SECTION_ID);
  var returnDetailsHelp = $('#returnDetailsHelp-' + SECTION_ID);
  var returnPhotos = $('#returnPhotos-' + SECTION_ID);
  var returnPhotosInput = $('#returnPhotosInput-' + SECTION_ID);
  var returnPhotosPreview = $('#returnPhotosPreview-' + SECTION_ID);
  var returnPhotosStatus = $('#returnPhotosStatus-' + SECTION_ID);
  var returnPhotosError = $('#returnPhotosError-' + SECTION_ID);

  var returnsAvailable = RETURNS_ENABLED && returnsFlow.length > 0 && !!contactReasonSelect;

  function getContactReason() {
    return contactReasonSelect ? contactReasonSelect.value : '';
  }

  function isReturnsActive() {
    return returnsAvailable && getContactReason() === 'returns';
  }

  function getReturnReason() {
    return form.find('input[name="returnReasonCode"]:checked').val() || '';
  }

  function getReturnSubreason() {
    return form.find('input[name="returnSubreasonCode"]:checked').val() || '';
  }

  function setFieldRequired(element, required) {
    if (!element) {
      return;
    }

    if (required) {
      element.setAttribute('required', 'required');
      element.setAttribute('aria-required', 'true');
    } else {
      element.removeAttribute('required');
      element.removeAttribute('aria-required');
    }
  }

  // Toggles visibility and keeps aria-hidden in sync. Hidden blocks use
  // `display: none`, so their controls stay out of the tab order.
  function toggleReturnsBlock(block, visible) {
    if (!block || !block.length) {
      return;
    }

    block.toggleClass('hidden', !visible);
    block.attr('aria-hidden', visible ? 'false' : 'true');
  }

  // Removes every trace of a jQuery Validate failure from a set of controls:
  // message label, error class, aria state and the validator's bookkeeping.
  // Safe to call before `form.validate()` has run.
  function clearFieldValidationState(elements) {
    if (!elements || !elements.length) {
      return;
    }

    var validator = form.data('validator');

    elements.each(function () {
      var element = this;
      var name = element.name;
      var isCheckable = element.type === 'radio' || element.type === 'checkbox';
      // jQuery Validate keys its message label by name for checkable controls
      // and by id for everything else.
      var errorKey = isCheckable ? name : element.id || name;

      $(element).removeClass('error').removeAttr('aria-invalid');

      if (errorKey) {
        form.find('label.error[for="' + errorKey + '"]').remove();
      }

      // The plugin appends `<id>-error` to aria-describedby; drop only that.
      var describedBy = element.getAttribute('aria-describedby');

      if (describedBy) {
        var kept = describedBy.split(/\s+/).filter(function (token) {
          return token && token.slice(-6) !== '-error';
        });

        if (kept.length) {
          element.setAttribute('aria-describedby', kept.join(' '));
        } else {
          element.removeAttribute('aria-describedby');
        }
      }

      if (!validator || !name) {
        return;
      }

      if (validator.submitted) {
        delete validator.submitted[name];
      }

      if (validator.invalid) {
        delete validator.invalid[name];
      }

      if (validator.errorMap) {
        delete validator.errorMap[name];
      }

      if (validator.errorList) {
        validator.errorList = validator.errorList.filter(function (error) {
          return error.element.name !== name;
        });
      }

      if (validator.successList) {
        validator.successList = validator.successList.filter(function (successElement) {
          return successElement.name !== name;
        });
      }
    });
  }

  function returnsControls() {
    return returnsFlow.find('input:not([type="hidden"]), select, textarea');
  }

  // Every returns control plus the order number, which lives outside the block.
  function clearReturnsValidationErrors() {
    if (!returnsAvailable) {
      return;
    }

    var controls = returnsControls();

    if (orderInput) {
      controls = controls.add(orderInput);
    }

    clearFieldValidationState(controls);
  }

  // Toggles required/aria-required on a radio group. Turning it off also
  // unchecks it, so no hidden radio can keep the group required.
  function setGroupRequired(group, required) {
    if (!group || !group.length) {
      return;
    }

    var radios = group.find('input[type="radio"]');

    radios.each(function () {
      setFieldRequired(this, required);
    });

    if (!required) {
      radios.prop('checked', false);
      clearFieldValidationState(radios);
    }
  }

  function setOrderRequired(required) {
    setFieldRequired(orderInput, required);
    orderRequiredMarker.toggleClass('hidden', !required);

    if (!required && orderInput) {
      clearFieldValidationState($(orderInput));
    }
  }

  // Details text never carries over between reason paths.
  function clearReturnDetails() {
    returnDetailsInput.val('');
    clearFieldValidationState(returnDetailsInput);
  }

  function hideReturnDetails() {
    toggleReturnsBlock(returnsDetails, false);
    setFieldRequired(returnDetailsInput.get(0), false);
    returnDetailsHelp.addClass('hidden').text('');
    clearReturnDetails();
    returnDetailsInput.removeAttr('aria-describedby');
  }

  function showReturnDetails(config) {
    returnDetailsLabel
      .text(config.label)
      .append(' ', $('<span>').attr('aria-hidden', 'true').text('*'));

    if (config.help) {
      returnDetailsHelp.removeClass('hidden').text(config.help);
      returnDetailsInput.attr('aria-describedby', 'returnDetailsHelp-' + SECTION_ID);
    } else {
      returnDetailsHelp.addClass('hidden').text('');
      returnDetailsInput.removeAttr('aria-describedby');
    }

    setFieldRequired(returnDetailsInput.get(0), true);
    toggleReturnsBlock(returnsDetails, true);
  }

  /*
   * Damage photos.
   *
   * Everything below is UX only. The Worker MUST repeat every check on its
   * side: photo count, individual size, combined size, MIME type, the real
   * file signature (magic bytes, not the browser reported type), a safe file
   * name, and the upload to Kustomer. A browser reported MIME type is not
   * proof of anything.
   */
  var returnPhotosAvailable =
    returnsAvailable && RETURN_PHOTOS_ENABLED && returnPhotos.length > 0;

  function shouldRequireReturnPhotos() {
    return returnPhotosAvailable && isReturnsActive() && getReturnReason() === 'damaged';
  }

  function formatReturnPhotoSize(bytes) {
    if (bytes >= 1024 * 1024) {
      return (bytes / (1024 * 1024)).toFixed(1) + ' MB';
    }

    return Math.max(1, Math.round(bytes / 1024)) + ' KB';
  }

  function clearReturnPhotosError() {
    returnPhotosError.addClass('hidden').text('');
    returnPhotosInput.removeAttr('aria-invalid');
  }

  function showReturnPhotosError(message) {
    returnPhotosError.removeClass('hidden').text(message);
    returnPhotosInput.attr('aria-invalid', 'true');
  }

  /*
   * The file input is cleared after every selection because the trusted
   * selection lives in returnPhotoFiles. The required state is enforced by
   * validateReturnsSubmission, not by native input validity, so the HTML
   * `required` attribute is deliberately never set here.
   */
  function setReturnPhotosRequired(required) {
    var input = returnPhotosInput.get(0);

    if (!input) {
      return;
    }

    if (required) {
      input.setAttribute('aria-required', 'true');
    } else {
      input.removeAttribute('aria-required');
    }
  }

  function revokeReturnPhotoObjectUrls() {
    returnPhotoObjectUrls.forEach(function (objectUrl) {
      URL.revokeObjectURL(objectUrl);
    });

    returnPhotoObjectUrls = [];
  }

  // Drops every selected file, its preview and its object URL.
  function clearReturnPhotos() {
    if (!returnPhotosAvailable) {
      return;
    }

    revokeReturnPhotoObjectUrls();
    returnPhotoFiles = [];
    returnPhotosPreview.empty();
    returnPhotosStatus.addClass('hidden').text('');
    returnPhotosInput.val('');
    clearReturnPhotosError();
    clearFieldValidationState(returnPhotosInput);
  }

  function hideReturnPhotos() {
    if (!returnPhotosAvailable) {
      return;
    }

    clearReturnPhotos();
    setReturnPhotosRequired(false);
    toggleReturnsBlock(returnPhotos, false);
  }

  function showReturnPhotos() {
    if (!returnPhotosAvailable) {
      return;
    }

    setReturnPhotosRequired(true);
    toggleReturnsBlock(returnPhotos, true);
  }

  function isAllowedReturnPhotoType(file) {
    return ALLOWED_RETURN_PHOTO_TYPES.indexOf(String(file.type).toLowerCase()) !== -1;
  }

  /*
   * Validates a batch as a whole: one bad file rejects the batch, so the
   * customer never ends up with a partially applied selection. Files already
   * accepted before this batch are preserved.
   *
   * The Worker repeats all of it and adds what a browser cannot be trusted for:
   * photo count, individual size, combined size, MIME type, the real file
   * signature (magic bytes), a safe file name, and the upload to Kustomer.
   */
  function validateReturnPhotoCandidates(candidates) {
    if (returnPhotoFiles.length + candidates.length > MAX_RETURN_PHOTO_COUNT) {
      return { ok: false, error: RETURN_PHOTO_MESSAGES.tooMany };
    }

    var totalBytes = returnPhotoFiles.reduce(function (total, file) {
      return total + file.size;
    }, 0);

    for (var index = 0; index < candidates.length; index += 1) {
      var candidate = candidates[index];

      // Neither the extension nor the reported type is trusted evidence; this
      // is a UX filter and the Worker checks the real signature.
      if (!isAllowedReturnPhotoType(candidate)) {
        return { ok: false, error: RETURN_PHOTO_MESSAGES.invalidType };
      }

      if (!candidate.size || candidate.size <= 0) {
        return { ok: false, error: RETURN_PHOTO_MESSAGES.emptyFile };
      }

      if (candidate.size > MAX_RETURN_PHOTO_SIZE_BYTES) {
        return { ok: false, error: RETURN_PHOTO_MESSAGES.tooLarge };
      }

      totalBytes += candidate.size;
    }

    if (totalBytes > MAX_RETURN_PHOTO_TOTAL_BYTES) {
      return { ok: false, error: RETURN_PHOTO_MESSAGES.totalTooLarge };
    }

    return { ok: true };
  }

  // File names and sizes are written with `.text()`: never innerHTML.
  function renderReturnPhotoPreviews() {
    revokeReturnPhotoObjectUrls();
    returnPhotosPreview.empty();

    returnPhotoFiles.forEach(function (file, index) {
      var objectUrl = URL.createObjectURL(file);
      returnPhotoObjectUrls.push(objectUrl);

      var item = $('<div>').addClass('returns-photo');

      item.append(
        $('<img>')
          .addClass('returns-photo__thumbnail')
          .attr({
            src: objectUrl,
            alt: file.name
              ? RETURN_PHOTO_MESSAGES.selectedPhotoAlt + ': ' + file.name
              : RETURN_PHOTO_MESSAGES.selectedPhotoAlt,
          })
      );

      var details = $('<div>').addClass('returns-photo__details');

      details.append($('<span>').addClass('returns-photo__name').text(file.name));
      details.append(
        $('<span>').addClass('returns-photo__size').text(formatReturnPhotoSize(file.size))
      );

      item.append(details);

      item.append(
        $('<button>')
          .addClass('returns-photo__remove')
          .attr({
            type: 'button',
            'aria-label':
              RETURN_PHOTO_MESSAGES.remove +
              ' ' +
              (file.name || RETURN_PHOTO_MESSAGES.selectedPhoto),
          })
          .attr('data-return-photo-index', String(index))
          .text(RETURN_PHOTO_MESSAGES.removePhoto)
      );

      returnPhotosPreview.append(item);
    });

    /*
     * The native input shows "No file chosen" again after every selection,
     * so this states what is actually held in memory.
     */
    if (returnPhotoFiles.length) {
      returnPhotosStatus
        .removeClass('hidden')
        .text(
          returnPhotoFiles.length === 1
            ? RETURN_PHOTO_MESSAGES.oneSelected
            : returnPhotoFiles.length + RETURN_PHOTO_MESSAGES.manySelectedSuffix
        );
    } else {
      returnPhotosStatus.addClass('hidden').text('');
    }
  }

  function handleReturnPhotosChange() {
    if (!returnPhotosAvailable) {
      return;
    }

    var input = returnPhotosInput.get(0);
    var candidates = input && input.files ? Array.prototype.slice.call(input.files) : [];

    // The input is emptied either way, so the same file can be picked again and
    // the element never holds a selection of its own.
    returnPhotosInput.val('');

    if (!candidates.length) {
      return;
    }

    var result = validateReturnPhotoCandidates(candidates);

    if (!result.ok) {
      showReturnPhotosError(result.error);
      return;
    }

    clearReturnPhotosError();
    returnPhotoFiles = returnPhotoFiles.concat(candidates);
    renderReturnPhotoPreviews();
  }

  function removeReturnPhoto(index) {
    if (!returnPhotosAvailable || index < 0 || index >= returnPhotoFiles.length) {
      return;
    }

    returnPhotoFiles.splice(index, 1);
    clearReturnPhotosError();
    renderReturnPhotoPreviews();
  }

  // Single source of truth for which conditional return blocks are visible and
  // which controls carry the required state.
  function updateReturnReasonFields() {
    var reason = getReturnReason();
    var showIncorrect = reason === 'incorrect_item';
    var showFit = reason === 'did_not_fit';

    toggleReturnsBlock(returnsSubreasonIncorrect, showIncorrect);
    toggleReturnsBlock(returnsSubreasonFit, showFit);

    // Turn the inapplicable group off first: both groups share the
    // `returnSubreasonCode` name, so this also clears its stale state.
    setGroupRequired(showIncorrect ? returnsSubreasonFit : returnsSubreasonIncorrect, false);
    setGroupRequired(returnsSubreasonIncorrect, showIncorrect);
    setGroupRequired(returnsSubreasonFit, showFit);

    var detailsConfig = RETURN_DETAILS_BY_REASON[reason];

    if (!detailsConfig && showIncorrect) {
      detailsConfig = RETURN_DETAILS_BY_SUBREASON[getReturnSubreason()];
    }

    if (detailsConfig) {
      showReturnDetails(detailsConfig);
    } else {
      hideReturnDetails();
    }

    if (shouldRequireReturnPhotos()) {
      showReturnPhotos();
    } else {
      hideReturnPhotos();
    }
  }

  function handleReturnReasonChange() {
    // A new reason invalidates the previous subreason and any details text
    // typed for the old path, but leaves unrelated field errors alone.
    clearFieldValidationState(form.find('input[name="returnReasonCode"]'));
    clearReturnDetails();
    updateReturnReasonFields();
  }

  function handleReturnSubreasonChange() {
    clearFieldValidationState(form.find('input[name="returnSubreasonCode"]'));
    updateReturnReasonFields();
  }

  function resetReturnsFlow() {
    toggleReturnsBlock(returnsFlow, false);
    toggleReturnsBlock(returnsItems, false);
    toggleReturnsBlock(returnsSubreasonIncorrect, false);
    toggleReturnsBlock(returnsSubreasonFit, false);
    hideReturnDetails();
    hideReturnPhotos();

    setGroupRequired(returnsReason, false);
    setGroupRequired(returnsSubreasonIncorrect, false);
    setGroupRequired(returnsSubreasonFit, false);

    returnsOrderStatus.addClass('hidden').text('');
    setOrderRequired(false);
    invalidateVerifiedOrder({ clearStatus: true });
    clearReturnsValidationErrors();
  }

  function showReturnsFlow() {
    toggleReturnsBlock(returnsFlow, true);
    setOrderRequired(true);
    setGroupRequired(returnsReason, true);
    updateReturnReasonFields();
  }

  // --- Order verification (POST /orders/verify) ---

  function returnsHiddenField(name) {
    return returnsFlow.find('input[type="hidden"][name="' + name + '"]');
  }

  function setReturnsHiddenField(name, value) {
    returnsHiddenField(name).val(value == null ? '' : String(value));
  }

  function clearReturnsHiddenFields() {
    setReturnsHiddenField('returnItemsJson', '');
    setReturnsHiddenField('returnItemsTxt', '');
    setReturnsHiddenField('returnItemCountNum', '');
    setReturnsHiddenField('returnRequestIdStr', '');
    setReturnsHiddenField('orderValidationStatusStr', '');
  }

  function focusWithoutScroll(element) {
    if (!element || typeof element.focus !== 'function') {
      return;
    }

    try {
      element.focus({ preventScroll: true });
    } catch (error) {
      element.focus();
    }
  }

  function setOrderStatus(message, options) {
    var settings = options || {};

    returnsOrderStatus.empty();

    if (!message) {
      returnsOrderStatus.addClass('hidden').removeClass('returns-order-status--error');
      return;
    }

    returnsOrderStatus
      .removeClass('hidden')
      .toggleClass('returns-order-status--error', !!settings.isError)
      .append($('<p>').addClass('returns-order-status__message').text(message));

    if (settings.notice) {
      returnsOrderStatus.append($('<p>').addClass('returns-help-text').text(settings.notice));
    }
  }

  function clearReturnsItemsError() {
    returnsItemsError.addClass('hidden').text('');
  }

  function showReturnsItemsError(message) {
    returnsItemsError.removeClass('hidden').text(message);
  }

  // Accepts a `#` pasted by the customer; everything after must be digits.
  function normalizeOrderNumber(value) {
    return String(value == null ? '' : value)
      .trim()
      .replace(/^#/, '')
      .trim();
  }

  function getTurnstileToken() {
    var token = form.find('[name="cf-turnstile-response"]').val();
    return token ? String(token).trim() : '';
  }

  function resetTurnstile() {
    if (window.turnstile && typeof window.turnstile.reset === 'function') {
      window.turnstile.reset();
    }
  }

  function setFindingOrder(active) {
    isFindingOrder = !!active;

    var button = findOrderButton.get(0);

    if (button) {
      button.disabled = isFindingOrder;

      if (isFindingOrder) {
        findOrderButton.attr('aria-disabled', 'true').text(ORDER_LOOKUP_MESSAGES.finding);
      } else {
        findOrderButton.removeAttr('aria-disabled').text(FIND_ORDER_LABEL);
      }
    }

    if (isFindingOrder) {
      returnsOrderStatus.attr('aria-busy', 'true');
    } else {
      returnsOrderStatus.removeAttr('aria-busy');
    }
  }

  // Drops the verified order and everything derived from it. Also cancels any
  // in-flight lookup so its response cannot repaint the UI.
  function invalidateVerifiedOrder(options) {
    var settings = options || {};

    verifiedOrderState = null;
    findOrderRequestSeq += 1;

    if (findOrderAbortController) {
      findOrderAbortController.abort();
      findOrderAbortController = null;
    }

    if (isFindingOrder) {
      setFindingOrder(false);
    }

    returnsItemsList.empty();
    toggleReturnsBlock(returnsItems, false);
    clearReturnsItemsError();
    clearReturnsHiddenFields();
    clearReturnPhotos();

    if (settings.clearStatus) {
      setOrderStatus('');
    }
  }

  function isSafeImageUrl(url) {
    return (
      typeof url === 'string' &&
      url.length <= MAX_RETURN_IMAGE_URL_LENGTH &&
      /^https:\/\//i.test(url)
    );
  }

  // Everything rendered comes from this allowlist, coerced to primitives.
  function normalizeOrderItems(rawItems) {
    if (!Array.isArray(rawItems)) {
      return [];
    }

    var items = [];

    rawItems.forEach(function (rawItem) {
      if (!rawItem || typeof rawItem !== 'object' || !rawItem.lineItemId) {
        return;
      }

      var quantity = Math.floor(Number(rawItem.quantity));

      items.push({
        lineItemId: String(rawItem.lineItemId),
        title: rawItem.title
          ? String(rawItem.title)
          : config.messages.items.fallbackTitle,
        variant: rawItem.variant ? String(rawItem.variant) : '',
        sku: rawItem.sku ? String(rawItem.sku) : '',
        quantity: quantity > 0 ? quantity : 1,
        imageUrl: isSafeImageUrl(rawItem.imageUrl) ? String(rawItem.imageUrl) : '',
        imageAlt:
          typeof rawItem.imageAlt === 'string'
            ? rawItem.imageAlt
                .replace(/\u0000/g, '')
                .trim()
                .slice(0, MAX_RETURN_IMAGE_ALT_LENGTH)
            : '',
      });
    });

    return items;
  }

  // Built with DOM APIs and `.text()` only: no API value ever becomes markup.
  function renderOrderItems(items) {
    returnsItemsList.empty();

    items.forEach(function (item, index) {
      var checkboxId = 'returnItem-' + index + '-' + SECTION_ID;
      var row = $('<div>').addClass('returns-item');

      var checkbox = $('<input>')
        .addClass('returns-item__checkbox')
        .attr({ type: 'checkbox', id: checkboxId })
        .attr('data-return-item-index', String(index));

      var label = $('<label>').addClass('returns-item__label').attr('for', checkboxId);

      label.append($('<span>').addClass('returns-item__title').text(item.title));

      if (item.variant) {
        label.append($('<span>').addClass('returns-item__meta').text(item.variant));
      }

      if (item.sku) {
        label.append(
          $('<span>')
            .addClass('returns-item__meta')
            .text(config.messages.items.skuPrefix + item.sku)
        );
      }

      label.append(
        $('<span>')
          .addClass('returns-item__meta')
          .text(config.messages.items.quantityPrefix + item.quantity)
      );

      if (item.imageUrl) {
        row.append(
          $('<img>')
            .addClass('returns-item__image')
            .attr({
              src: item.imageUrl,
              alt: item.imageAlt || item.title,
              loading: 'lazy',
            })
        );
      }

      row.append(checkbox, label);
      returnsItemsList.append(row);
    });
  }

  function getSelectedReturnItems() {
    if (!verifiedOrderState) {
      return [];
    }

    var selected = [];

    returnsItemsList.find('input[type="checkbox"]:checked').each(function () {
      var item = verifiedOrderState.items[Number(this.getAttribute('data-return-item-index'))];

      if (item) {
        selected.push(item);
      }
    });

    return selected;
  }

  /*
   * imageUrl and imageAlt intentionally stay out of returnItemsJson.
   *
   * The browser uses them only to render the verified order UI. The Worker
   * obtains trusted catalog image data from the signed order-validation token.
   */
  function toReturnItemPayload(item) {
    return {
      lineItemId: item.lineItemId,
      title: item.title,
      variant: item.variant,
      sku: item.sku,
      quantity: item.quantity,
    };
  }

  function toReturnItemSummary(item) {
    var parts = [item.title];

    if (item.variant) {
      parts.push(item.variant);
    }

    if (item.sku) {
      parts.push(config.messages.items.skuPrefix + item.sku);
    }

    parts.push(config.messages.items.quantityPrefix + item.quantity);

    return parts.join(' | ');
  }

  // `returnItemCountNum` counts selected line items, not summed quantities.
  function updateSelectedReturnItems() {
    var selected = getSelectedReturnItems();

    if (!selected.length) {
      setReturnsHiddenField('returnItemsJson', '');
      setReturnsHiddenField('returnItemsTxt', '');
      setReturnsHiddenField('returnItemCountNum', '');
      return;
    }

    setReturnsHiddenField('returnItemsJson', JSON.stringify(selected.map(toReturnItemPayload)));
    setReturnsHiddenField('returnItemsTxt', selected.map(toReturnItemSummary).join('\n'));
    setReturnsHiddenField('returnItemCountNum', String(selected.length));
    clearReturnsItemsError();
  }

  function parseJsonSafely(body) {
    if (!body) {
      return null;
    }

    try {
      return JSON.parse(body);
    } catch (error) {
      return null;
    }
  }

  function getVerifyErrorCode(payload) {
    if (!payload) {
      return '';
    }

    if (typeof payload.error === 'string') {
      return payload.error;
    }

    if (payload.error && typeof payload.error.code === 'string') {
      return payload.error.code;
    }

    if (typeof payload.code === 'string') {
      return payload.code;
    }

    return '';
  }

  function isSuccessfulVerify(result) {
    var payload = result.payload;

    return !!(
      result.ok &&
      payload &&
      payload.ok === true &&
      payload.requestId &&
      payload.data &&
      payload.data.validationToken &&
      payload.data.order &&
      Array.isArray(payload.data.order.items) &&
      payload.data.order.items.length
    );
  }

  // Never surfaces internal detail; the requestId stays out of the message.
  function messageForVerifyFailure(result) {
    var code = getVerifyErrorCode(result.payload);
    var status = result.status;

    if (code === 'invalid_email') {
      return ORDER_LOOKUP_MESSAGES.invalidEmail;
    }

    if (code === 'invalid_order') {
      return ORDER_LOOKUP_MESSAGES.invalidOrder;
    }

    if (code === 'turnstile_token_missing') {
      return ORDER_LOOKUP_MESSAGES.turnstileMissing;
    }

    if (status === 403) {
      return ORDER_LOOKUP_MESSAGES.securityExpired;
    }

    if (status === 404 || code === 'order_not_verified') {
      return ORDER_LOOKUP_MESSAGES.notVerified;
    }

    if (status === 503) {
      return ORDER_LOOKUP_MESSAGES.busy;
    }

    return ORDER_LOOKUP_MESSAGES.generic;
  }

  function applyVerifiedOrder(payload, email, orderNumber) {
    var items = normalizeOrderItems(payload.data.order.items);

    if (!items.length) {
      setOrderStatus(ORDER_LOOKUP_MESSAGES.notVerified, { isError: true });
      return;
    }

    verifiedOrderState = {
      email: email,
      orderNumber: orderNumber,
      validationToken: payload.data.validationToken,
      requestId: String(payload.requestId),
      items: items,
    };

    renderOrderItems(items);
    toggleReturnsBlock(returnsItems, true);

    setReturnsHiddenField('returnRequestIdStr', verifiedOrderState.requestId);
    setReturnsHiddenField('orderValidationStatusStr', 'verified');
    updateSelectedReturnItems();

    setOrderStatus(ORDER_LOOKUP_MESSAGES.found, {
      notice: ORDER_LOOKUP_MESSAGES.turnstileNotice,
    });

    focusWithoutScroll(returnsItemsList.find('input[type="checkbox"]').get(0));
  }

  function handleFindOrder() {
    if (!isReturnsActive() || isFindingOrder) {
      return;
    }

    form.find('.contact-turnstile-error').addClass('hidden');

    var email = emailInput ? emailInput.value.trim() : '';

    if (emailInput) {
      emailInput.value = email;
    }

    var orderNumber = normalizeOrderNumber(orderInput ? orderInput.value : '');

    if (orderInput) {
      orderInput.value = orderNumber;
    }

    // A new lookup always discards the previous result.
    invalidateVerifiedOrder({ clearStatus: true });

    if (!EMAIL_PATTERN.test(email)) {
      setOrderStatus(ORDER_LOOKUP_MESSAGES.invalidEmail, { isError: true });
      focusWithoutScroll(emailInput);
      return;
    }

    if (!/^\d+$/.test(orderNumber)) {
      setOrderStatus(ORDER_LOOKUP_MESSAGES.invalidOrder, { isError: true });
      focusWithoutScroll(orderInput);
      return;
    }

    var turnstileToken = getTurnstileToken();

    if (!turnstileToken) {
      setOrderStatus(ORDER_LOOKUP_MESSAGES.turnstileMissing, { isError: true });
      form.find('.contact-turnstile-error').removeClass('hidden');
      return;
    }

    findOrderRequestSeq += 1;

    var requestSeq = findOrderRequestSeq;
    var controller = typeof AbortController === 'function' ? new AbortController() : null;

    findOrderAbortController = controller;

    setFindingOrder(true);
    setOrderStatus(ORDER_LOOKUP_MESSAGES.finding);

    // No automatic retry: every attempt consumes a single-use Turnstile token.
    fetch(ORDER_VERIFY_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        email: email,
        orderNumber: orderNumber,
        turnstileToken: turnstileToken,
      }),
      signal: controller ? controller.signal : undefined,
    })
      .then(function (response) {
        // Error responses are not guaranteed to be JSON.
        return response.text().then(function (body) {
          return {
            ok: response.ok,
            status: response.status,
            payload: parseJsonSafely(body),
          };
        });
      })
      .then(function (result) {
        if (requestSeq !== findOrderRequestSeq) {
          return;
        }

        if (isSuccessfulVerify(result)) {
          applyVerifiedOrder(result.payload, email, orderNumber);
        } else {
          setOrderStatus(messageForVerifyFailure(result), { isError: true });
        }
      })
      .catch(function (error) {
        if (requestSeq !== findOrderRequestSeq || (error && error.name === 'AbortError')) {
          return;
        }

        setOrderStatus(ORDER_LOOKUP_MESSAGES.generic, { isError: true });
      })
      .then(function () {
        if (requestSeq === findOrderRequestSeq) {
          setFindingOrder(false);
          findOrderAbortController = null;
        }

        // Single-use token: always burn it, success or failure.
        resetTurnstile();
      });
  }

  function getCurrentOrderIdentity() {
    return {
      email: emailInput ? emailInput.value.trim().toLowerCase() : '',
      orderNumber: normalizeOrderNumber(orderInput ? orderInput.value : ''),
    };
  }

  function hasVerifiedOrderIdentityChanged() {
    if (!verifiedOrderState) {
      return false;
    }

    var currentIdentity = getCurrentOrderIdentity();

    return (
      currentIdentity.email !==
        String(verifiedOrderState.email || '')
          .trim()
          .toLowerCase() ||
      currentIdentity.orderNumber !== String(verifiedOrderState.orderNumber || '')
    );
  }

  function handleVerifiedOrderInputChange() {
    /*
     * A lookup in progress must still be cancelled when the customer edits
     * the order identity.
     */
    if (isFindingOrder) {
      invalidateVerifiedOrder({ clearStatus: true });
      return;
    }

    if (!verifiedOrderState) {
      return;
    }

    /*
     * Ignore incidental input/change events that do not alter the normalized
     * email or order number. This preserves selected damage photos when
     * client-side validation focuses or revalidates another field.
     */
    if (!hasVerifiedOrderIdentityChanged()) {
      return;
    }

    invalidateVerifiedOrder({ clearStatus: true });
  }

  // Re-checked immediately before serialization: the token must still exist and
  // the identity of the order must not have drifted.
  function isVerifiedOrderStillValid() {
    if (!verifiedOrderState || !verifiedOrderState.validationToken) {
      return false;
    }

    var email = emailInput ? emailInput.value.trim().toLowerCase() : '';
    var orderNumber = normalizeOrderNumber(orderInput ? orderInput.value : '');

    return (
      verifiedOrderState.email.toLowerCase() === email &&
      verifiedOrderState.orderNumber === orderNumber &&
      returnsHiddenField('orderValidationStatusStr').val() === 'verified'
    );
  }

  // Drops the verification and asks the customer to look the order up again.
  function expireVerifiedOrder() {
    invalidateVerifiedOrder({ clearStatus: true });
    showReturnsItemsError(RETURNS_SUBMIT_MESSAGES.verificationExpired);
    focusWithoutScroll(findOrderButton.get(0));
  }

  function getResponseErrorCode(xhr) {
    if (!xhr) {
      return '';
    }

    var payload = xhr.responseJSON;

    if (!payload && xhr.responseText) {
      payload = parseJsonSafely(xhr.responseText);
    }

    return getVerifyErrorCode(payload);
  }

  // Blocks the final submit while the returns flow lacks a verified order or a
  // selection. No-op for every other Contact Reason and with the flag off.
  function validateReturnsSubmission() {
    if (!isReturnsActive()) {
      return true;
    }

    if (!verifiedOrderState) {
      showReturnsItemsError(RETURNS_SUBMIT_MESSAGES.orderNotVerified);
      focusWithoutScroll(findOrderButton.get(0));
      return false;
    }

    if (!isVerifiedOrderStillValid()) {
      expireVerifiedOrder();
      return false;
    }

    if (!getSelectedReturnItems().length) {
      showReturnsItemsError(RETURNS_SUBMIT_MESSAGES.noItemsSelected);
      focusWithoutScroll(returnsItemsList.find('input[type="checkbox"]').get(0));
      return false;
    }

    // Damage photos are required only for `damaged`, and only with the photo
    // flag on. A missing photo does not invalidate the verified order.
    if (shouldRequireReturnPhotos() && !returnPhotoFiles.length) {
      clearReturnsItemsError();
      showReturnPhotosError(RETURN_PHOTO_MESSAGES.required);
      focusWithoutScroll(returnPhotosInput.get(0));
      return false;
    }

    clearReturnsItemsError();
    return true;
  }

  function handleContactReasonChange() {
    if (!returnsAvailable) {
      return;
    }

    if (isReturnsActive()) {
      showReturnsFlow();
    } else {
      resetReturnsFlow();
    }
  }

  if (returnsAvailable) {
    // Namespaced + deduped so a Theme Editor re-render never stacks listeners.
    $(contactReasonSelect)
      .off('change.returnsFlow')
      .on('change.returnsFlow', handleContactReasonChange);

    form
      .off('change.returnsReason')
      .on('change.returnsReason', 'input[name="returnReasonCode"]', handleReturnReasonChange);

    form
      .off('change.returnsSubreason')
      .on('change.returnsSubreason', 'input[name="returnSubreasonCode"]', handleReturnSubreasonChange);

    findOrderButton
      .off('click.returnsFindOrder')
      .on('click.returnsFindOrder', handleFindOrder);

    // Any change to the identity of the order invalidates the lookup.
    $(emailInput)
      .off('input.returnsOrder change.returnsOrder')
      .on('input.returnsOrder change.returnsOrder', handleVerifiedOrderInputChange);

    $(orderInput)
      .off('input.returnsOrder change.returnsOrder')
      .on('input.returnsOrder change.returnsOrder', handleVerifiedOrderInputChange);

    // Delegated on the stable list container so re-rendered items stay wired.
    returnsItemsList
      .off('change.returnsItems')
      .on('change.returnsItems', 'input[type="checkbox"]', updateSelectedReturnItems);

    if (returnPhotosAvailable) {
      returnPhotosInput
        .off('change.returnPhotos')
        .on('change.returnPhotos', handleReturnPhotosChange);

      returnPhotosPreview
        .off('click.returnPhotos')
        .on('click.returnPhotos', '.returns-photo__remove', function () {
          removeReturnPhoto(Number(this.getAttribute('data-return-photo-index')));
          focusWithoutScroll(returnPhotosInput.get(0));
        });

      // A Theme Editor re-render starts from an empty selection.
      clearReturnPhotos();
    }
  }

  // --- jQuery Validate ---
  form.validate({
    rules: {
      name: {
        required: true,
        maxlength: 60,
      },
      email: {
        required: true,
        email: true,
        maxlength: 254,
      },
      subject: {
        required: true,
        maxlength: 180,
      },
      contactReason2025TreeTree: {
        required: true,
      },
      message: {
        required: true,
        maxlength: 5000,
      },
      // Returns rules only ever fire while the flow is active. jQuery Validate
      // skips `:hidden` fields by default, so collapsed blocks never block submit.
      order: {
        required: {
          depends: isReturnsActive,
        },
      },
      returnReasonCode: {
        required: {
          depends: isReturnsActive,
        },
      },
      returnSubreasonCode: {
        required: {
          depends: function () {
            var reason = getReturnReason();
            return isReturnsActive() && (reason === 'incorrect_item' || reason === 'did_not_fit');
          },
        },
      },
      returnDetailsTxt: {
        required: {
          depends: function () {
            return isReturnsActive() && !returnsDetails.hasClass('hidden');
          },
        },
        maxlength: 1000,
      },
      /*
       * The native file input is cleared after each selection because the
       * accepted files live in returnPhotoFiles. jQuery Validate must not
       * enforce a required rule for the input itself; validateReturnsSubmission
       * checks the in-memory array when damaged-item photos are required.
       */
      returnPhotos: {
        required: false,
      },
    },
    messages: {
      name: {
        required: config.messages.validation.nameRequired,
        maxlength: config.messages.validation.nameMaxlength,
      },
      email: {
        required: config.messages.validation.emailRequired,
        email: config.messages.validation.emailInvalid,
        maxlength: config.messages.validation.emailMaxlength,
      },
      subject: {
        required: config.messages.validation.subjectRequired,
        maxlength: config.messages.validation.subjectMaxlength,
      },
      contactReason2025TreeTree: config.messages.validation.contactReasonRequired,
      message: {
        required: config.messages.validation.messageRequired,
        maxlength: config.messages.validation.messageMaxlength,
      },
      order: config.messages.validation.orderRequired,
      returnReasonCode: config.messages.validation.returnReasonRequired,
      returnSubreasonCode: config.messages.validation.returnSubreasonRequired,
      returnDetailsTxt: {
        required: config.messages.validation.returnDetailsRequired,
        maxlength: config.messages.validation.returnDetailsMaxlength,
      },
    },
    invalidHandler: function (event, validator) {
      /*
       * Client-side validation must never discard an accepted upload.
       * The in-memory array is the source of truth because the native file
       * input is intentionally cleared after selection.
       */
      if (
        returnPhotosAvailable &&
        returnPhotoFiles.length > 0 &&
        returnPhotosPreview.find('.returns-photo').length !== returnPhotoFiles.length
      ) {
        renderReturnPhotoPreviews();
      }

      if (validator.errorList.length) {
        focusWithoutScroll(validator.errorList[0].element);
      }
    },
    success: function (label) {
      label.remove();
    },
    highlight: function (element, errorClass) {
      $(element)
        .parent()
        .find('.' + errorClass)
        .removeClass('checked');
    },
    errorPlacement: function (error, e) {
      // Radio groups have no single anchor input, so the message goes at the
      // end of their fieldset instead of before the first radio.
      var optionGroup = e.closest('.returns-reason, .returns-subreason');

      if (optionGroup.length) {
        optionGroup.append(error);
        return;
      }

      error.insertBefore(e);
    },
  });

  // Runs after the validator exists so the returns cleanup can use it. Syncs
  // with any Contact Reason restored by the browser or the Theme Editor.
  if (returnsAvailable) {
    handleContactReasonChange();
  }

  // --- Submit handler (namespaced, deduped) ---
  form.off('submit.contactForm').on('submit.contactForm', function (e) {
    e.preventDefault();

    if (isSubmitting) {
      return;
    }

    if (!form.valid()) {
      return;
    }

    if (!validatePhone()) {
      return;
    }

    if (!validateReturnsSubmission()) {
      return;
    }

    // Captured now: the Contact Reason may change while the request is in
    // flight, but this submission's shape must not.
    var isReturnsSubmission = isReturnsActive();

    var formData = form.serializeArray().reduce(function (a, field) {
      a[field.name] = field.value;
      return a;
    }, {});

    if (isReturnsSubmission) {
      // Unchecked radio groups are absent from serializeArray, so the Worker
      // would see a missing key instead of an empty one.
      if (typeof formData.returnReasonCode !== 'string') {
        formData.returnReasonCode = '';
      }

      if (typeof formData.returnSubreasonCode !== 'string') {
        formData.returnSubreasonCode = '';
      }

      // The token lives only in the closure: it is added to the payload here and
      // never written to the DOM, storage or a data attribute.
      formData.returnValidationToken = verifiedOrderState.validationToken;
    } else {
      // Non-returns submissions keep the original payload: no residual returns
      // value may reach Kustomer.
      RETURNS_PAYLOAD_FIELDS.forEach(function (fieldName) {
        delete formData[fieldName];
      });
    }

    // Turnstile token check
    var turnstileToken = formData['cf-turnstile-response'];

    if (!turnstileToken) {
      form.find('.contact-turnstile-error').removeClass('hidden');
      return;
    }

    form.find('.contact-turnstile-error').addClass('hidden');

    // Phone in international format
    formData.phone = iti.getNumber();

    // Size calculation
    formData.size = '' + formData.message.length;

    // Build combined subject
    var contactReasonLabel = form.find('#contactReason-' + SECTION_ID + ' option:selected').text();
    var subjectParts = ['[WEB] ' + contactReasonLabel];
    if (formData.order) {
      subjectParts.push('Order #' + formData.order);
    }
    subjectParts.push(formData.subject);
    formData.subject = subjectParts.join(' | ');

    // Defensive subject length check
    if (formData.subject.length > 250) {
      showFormError();
      isSubmitting = false;
      return;
    }

    isSubmitting = true;

    /*
     * Single source of truth for sending files. Photos travel only for a
     * damaged returns request that actually has files, so every other
     * submission keeps the original url-encoded transport untouched.
     */
    var shouldSendPhotos =
      isReturnsSubmission && shouldRequireReturnPhotos() && returnPhotoFiles.length > 0;

    var ajaxData = formData;
    var ajaxProcessData = true;
    var ajaxContentType = 'application/x-www-form-urlencoded; charset=UTF-8';

    if (shouldSendPhotos) {
      ajaxData = new FormData();

      Object.keys(formData).forEach(function (key) {
        ajaxData.append(key, formData[key]);
      });

      returnPhotoFiles.forEach(function (file) {
        ajaxData.append('returnPhotos', file, file.name);
      });

      // The browser writes Content-Type with the multipart boundary.
      ajaxProcessData = false;
      ajaxContentType = false;
    }

    $.ajax({
      type: 'POST',
      url: config.contactUrl,
      crossDomain: true,
      data: ajaxData,
      processData: ajaxProcessData,
      contentType: ajaxContentType,
      beforeSend: function () {
        form.find('.form-error').addClass('hidden');
        setFormSubmitting(true);
      },
      success: function () {
        setFormSubmitted();
        form.find('.contact-success-btn').removeClass('hidden');
        showFormSuccess();
        sessionStorage.setItem(CONTACT_SENT_KEY, String(Date.now()));

        // Files and their object URLs are released once the request succeeded.
        clearReturnPhotos();
      },
      error: function (error) {
        console.error('Contact form submission failed:', {
          status: error.status,
        });

        form.find('.contact-success-btn').addClass('hidden');
        setFormSubmitting(false);

        if (
          window.turnstile &&
          typeof window.turnstile.reset === 'function'
        ) {
          window.turnstile.reset();
        }

        // A rejected return validation means the lookup must start over.
        if (isReturnsSubmission) {
          var returnErrorCode = getResponseErrorCode(error);

          if (RETURN_VALIDATION_ERROR_CODES.indexOf(returnErrorCode) !== -1) {
            form.find('.form-error').addClass('hidden');
            expireVerifiedOrder();
          } else if (returnErrorCode === 'return_request_payload_mismatch') {
            // The signed request no longer matches: a new lookup is required.
            form.find('.form-error').addClass('hidden');
            invalidateVerifiedOrder({ clearStatus: true });
            showReturnsItemsError(RETURN_IDEMPOTENCY_MESSAGES[returnErrorCode]);
            focusWithoutScroll(findOrderButton.get(0));
          } else if (RETURN_IDEMPOTENCY_MESSAGES[returnErrorCode]) {
            /*
             * Already in progress or of unknown outcome: the photos and the
             * verified order are kept, and nothing is re-sent automatically.
             */
            form.find('.form-error').addClass('hidden');
            showReturnsItemsError(RETURN_IDEMPOTENCY_MESSAGES[returnErrorCode]);
          } else {
            showFormError();
          }
        } else {
          showFormError();
        }
      },
    });
  });

    function destroy() {
      findOrderRequestSeq += 1;

      if (findOrderAbortController) {
        findOrderAbortController.abort();
        findOrderAbortController = null;
      }

      revokeReturnPhotoObjectUrls();
      returnPhotoFiles = [];
      returnPhotoObjectUrls = [];

      inputPhone.removeEventListener('blur', handlePhoneBlur);
      inputPhone.removeEventListener('change', resetPhoneError);
      inputPhone.removeEventListener('keyup', resetPhoneError);

      $(contactReasonSelect).off('.returnsFlow');
      $(emailInput).off('.returnsOrder');
      $(orderInput).off('.returnsOrder');
      findOrderButton.off('.returnsFindOrder');
      returnsItemsList.off('.returnsItems');
      returnPhotosInput.off('.returnPhotos');
      returnPhotosPreview.off('.returnPhotos');
      form.off('.returnsReason');
      form.off('.returnsSubreason');
      form.off('.contactForm');

      var validator = form.data('validator');

      if (validator && typeof validator.destroy === 'function') {
        validator.destroy();
      }

      if (iti && typeof iti.destroy === 'function') {
        iti.destroy();
      }

      verifiedOrderState = null;
      form = null;
      formElement = null;
      inputPhone = null;
      errorMsg = null;
      iti = null;
    }

    instances.set(SECTION_ID, {
      destroy: destroy,
    });
  }

  function destroySection(sectionId) {
    var normalizedSectionId = String(sectionId || '');
    var instance = instances.get(normalizedSectionId);

    if (!instance) {
      return;
    }

    instance.destroy();
    instances.delete(normalizedSectionId);
  }

  window.ArezzoCustomContactForm = {
    initializeAll: initializeAll,
    destroySection: destroySection,
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initializeAll(document);
    });
  } else {
    initializeAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initializeAll(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var sectionId =
      event && event.detail ? String(event.detail.sectionId || '') : '';

    destroySection(sectionId);
  });
})();
